import { ace_index } from '@axo/shared/data-access/types';
import { Dispatch, SetStateAction } from 'react';
import { MultiFilterSelect } from '../MultiFilterSelect';
import { setPageNumber } from '../SearchResults';
import { ace_index_hooks } from '@axo/shared/data-access/hooks';

interface PaymentRemarkStatus {
  Code: number;
  Name: string;
}

interface PaymentRemarkStatusProps {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export const PaymentRemarkStatus: React.FC<PaymentRemarkStatusProps> = ({
  query,
  setQuery,
  editable = false,
}) => {
  const { data } = ace_index_hooks.useACEIndexOptions();
  const paymentRemarkStatusMap = data?.PaymentRemarkStatusMap ?? {};

  const selectedCodes = query.PersonPaymentRemarkStatusCodes ?? [];
  const items = Object.entries(paymentRemarkStatusMap).map(([Name, Code]) => ({
    Name,
    Code,
  }));
  const values = items.filter((item) => selectedCodes.includes(item.Code));

  return (
    <MultiFilterSelect<PaymentRemarkStatus>
      key="payment-remark-status"
      items={items}
      values={values}
      onSelect={(option) => setQuery(addStatus(option))}
      onRemove={(_, i) => setQuery(removeStatus(values[i]))}
      stringify={(option) => option.Name}
      label="Payment Remark Status"
      disabled={!editable}
    />
  );
};

function addStatus(
  status: PaymentRemarkStatus
): SetStateAction<ace_index.FindInput> {
  return (query) => {
    const statuses = new Set(query.PersonPaymentRemarkStatusCodes);

    if (statuses.has(status.Code)) {
      statuses.delete(status.Code);
    } else {
      statuses.add(status.Code);
    }

    const next = Array.from(statuses.values());

    return {
      ...setPageNumber(1)(query),
      PersonPaymentRemarkStatusCodes: next.length > 0 ? next : undefined,
    };
  };
}

function removeStatus(
  status: PaymentRemarkStatus
): SetStateAction<ace_index.FindInput> {
  return (query) => {
    const statuses = new Set(query.PersonPaymentRemarkStatusCodes);
    statuses.delete(status.Code);
    const next = Array.from(statuses.values());

    return {
      ...setPageNumber(1)(query),
      PersonPaymentRemarkStatusCodes: next.length > 0 ? next : undefined,
    };
  };
}
